import {
  ClientProvider,
  ProviderPriority,
  SupportedChainId,
  toClientProvider,
} from "@silo/types";
import {
  FallbackProvider,
  StaticJsonRpcProvider,
} from "@ethersproject/providers";
import { getProxyRpcUrl } from "./proxy-rpc";

/**
 * All client-side RPC reads now tunnel through the same-origin proxy at
 * `/api/network/[chainKey]`, so provider URLs and keys never ship in the
 * browser bundle. The proxy performs the drpc/alchemy/infura fallback
 * server-side, so a single client-side provider is sufficient — the previous
 * 3-provider `FallbackProvider` would just triple proxy traffic.
 *
 * `providerPriority` is kept in the signature for call-site compatibility but
 * is no longer used now that fallback happens on the server.
 */
export function createClientProvider(
  chainId: SupportedChainId,
  _providerPriority: ProviderPriority
): ClientProvider {
  const provider = new StaticJsonRpcProvider(getProxyRpcUrl(chainId), chainId);

  // Keep the FallbackProvider shape so the `ClientProvider` brand and all
  // existing consumers continue to work unchanged.
  return toClientProvider(new FallbackProvider([{ provider }], 1));
}
